import { type AlertDialogPopupProps, AlertDialog as BaseAlertDialog } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import { statusColorThemes } from '~/styles/themes.css';
import { clsxs } from '~/styles/utils';

import type { IconName } from '../Icon/Icon';

import { Button } from '../Button/Button';
import { backdropStyle } from '../Dialog/Dialog.css';
import { IconBubble } from '../IconBubble/IconBubble';
import { closeButtonStyle, popupStyle } from './AlertDialog.css';

type Props = AlertDialogPopupProps & {
  hideCloseButton?: boolean;
  icon?: false | IconName;
  status: keyof typeof statusColorThemes;
};

const defaultIcons = {
  danger: 'Error',
  discovery: 'Info',
  info: 'Info',
  neutral: 'Info',
  success: 'Check',
  warning: 'Warning',
} as const satisfies Record<Props['status'], false | IconName>;

export const AlertDialogBody = ({ children, hideCloseButton, icon, status, ...delegated }: Props) => {
  const iconName = icon !== undefined ? icon : defaultIcons[status];
  const { t } = useTranslation(['common']);

  return (
    <BaseAlertDialog.Portal>
      <BaseAlertDialog.Backdrop className={backdropStyle} />

      <BaseAlertDialog.Popup {...delegated} className={clsxs(statusColorThemes[status], popupStyle, delegated.className)}>
        {!hideCloseButton && (
          <BaseAlertDialog.Close
            render={<Button aria-label={t('common:actions.close')} className={closeButtonStyle} icon="CloseSmall" />}
          />
        )}

        {iconName && <IconBubble icon={iconName} />}

        {children}
      </BaseAlertDialog.Popup>
    </BaseAlertDialog.Portal>
  );
};
